// extracted by mini-css-extract-plugin
module.exports = {"galerie":"galerie_galerie__391lk","nadpis":"galerie_nadpis__3pj72","block":"galerie_block__1LowT","containerImg":"galerie_containerImg__33fD3","img":"galerie_img__2pUA9"};